/* eslint-ignore */
// @ts-nocheck
import dateFormat from 'dateformat';
import moment from 'moment';
import React, { Component } from 'react';
import Currency from 'react-currency-formatter';
import TagManager from 'react-gtm-module';
import { toast } from 'react-toastify';
import { SlOptions } from 'react-icons/sl';

import api from 'services/api';
import firebase from 'services/firebase';
import CustomToolip from './CustomToolip';

import {
  Card,
  CardLine,
  CardTop,
  Code,
  CodeTitle,
  DescriptionLine,
  DuplicateContainer,
  DuplicateIcon,
  DuplicateLoading,
  Hr,
  OptionsIcon,
  Status,
  StatusTitle,
  Td,
  TitleLine,
  Tr,
  SelectedItem,
  DescriptionTooltip,
  BankslipInformations,
  Item,
  ItemDescription,
  ItemWrap,
} from './styles';

dateFormat.i18n = {
  dayNames: [
    'Seg',
    'Ter',
    'Qua',
    'Qui',
    'Sex',
    'Sab',
    'Dom',
    'Segunda-feira',
    'Terça-feira',
    'Quarta-feira',
    'Quinta-feira',
    'Sexta-feira',
    'Sábado',
    'Domingo',
  ],
  monthNames: [
    'Jan',
    'Feb',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  timeNames: ['a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'],
};

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      invoice: '',
      loadingDownload: false,
      loadingEmail: false,
      status: null,
      customerType: localStorage.getItem('@UltragazEmpresarial:customerType'),
    };
  }

  componentDidMount() {
    const { invoice, installment, status } = this.props;
    this.organizeData(invoice, installment);
  }

  organizeData = async (invoice, installment) => {
    this.setState({ loading: true });
    const { customer } = invoice;
    return await this.setState({
      token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      invoice,
      customer,
      installment,
    });
  };

  handleOpenModal = (event, openModal, download, sendEmail, selectItem) => {
    if (event) event.stopPropagation();

    if (openModal) {
      this.props.open();
    } else if (download) {
      this.requestDownloadBoleto();
    } else if (sendEmail) {
      this.requestEmailBoleto();
    } else if (selectItem) {
      this.props.selectItem();
    }
  };

  requestDownloadBoleto = () => {
    if (this.state.customerType === 'Granel') {
      this.requestDownloadBoletoGranel();
    }
    if (this.state.customerType === 'MI') {
      this.requestDownloadBoletoMi();
    }
  };

  requestEmailBoleto = () => {
    if (this.state.customerType === 'Granel') {
      this.requestEmailBoletoGranel();
    }
    if (this.state.customerType === 'MI') {
      this.requestEmailBoletoMi();
    }
  };

  requestDownloadBoletoGranel = () => {
    this.setState({ loadingDownload: true });
    const { customer, invoice, installment } = this.state;
    firebase.analytics().logEvent('download_boleto', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      responseType: 'blob',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      customerCode: customer.code,
      customerSiteCode: customer.siteCode,
      deliveryMethod: 'DOWNLOAD',
      ...(contactIdSf && { contactIdSf }),
    };
    api
      .post(
        `industrial/invoice/v1/invoices/${this.props.invoice.invoiceId}/installments/${this.props.installment.installmentId}/bankslips`,
        body,
        parameters
      )
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${this.state.installment.installmentId}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.setState({ loadingDownload: false });
      })
      .catch((err) => {
        this.setState({ loadingDownload: false });
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  requestEmailBoletoGranel = () => {
    this.analisticsEmailBoleto();
    this.setState({ loadingEmail: true });
    try {
      const { customer, invoice, installment } = this.state;
      const email = localStorage.getItem('@UltragazEmpresarial:loginEmail');
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
      };
      const parameters = {
        method: 'POST',
        headers: header,
      };
      const contactIdSf = localStorage.getItem(
        '@UltragazEmpresarial:contactIdSf'
      );
      const body = {
        customerCode: customer.code,
        customerSiteCode: customer.siteCode,
        deliveryMethod: 'EMAIL',
        ...(contactIdSf && { contactIdSf }),
      };
      api
        .post(
          `industrial/invoice/v1/invoices/${invoice.invoiceId}/installments/${installment.installmentId}/bankslips`,
          body,
          parameters
        )
        .then((res) => {
          this.setState({ loadingEmail: false });
          toast.success(`Boleto enviado para o e-mail: ${email}`);
        })
        .catch((err) => {
          this.setState({ loadingEmail: false });
        });
    } catch (err) {
      this.setState({ loadingEmail: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  };

  requestDownloadBoletoMi = async () => {
    this.analyticsDownloadBoleto();
    this.setState({ loadingDownload: true });
    try {
      const headers = {
        access_token: this.state.token,
      };
      const body = {
        deliveryMethod: 'DOWNLOAD',
        email: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        isReduced: false,
      };
      const response = await api.post(
        `industrial/bill/v1/bills/${this.state.invoice.id}`,
        body,
        { headers, responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const referenceMonth = (
        this.state.installment.referenceMonth || ''
      ).split('/');
      link.setAttribute(
        'download',
        `Ultragaz_${(
          dateFormat(
            `${parseInt(referenceMonth[1])}/` + `01` + `/${referenceMonth[0]}`,
            'mmmyyyy'
          ) || ''
        ).toUpperCase()}_${this.state.invoice.id}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      this.setState({ loadingDownload: false });
    } catch (err) {
      this.setState({ loadingDownload: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  };

  requestEmailBoletoMi = async () => {
    toast.dismiss();
    this.analisticsEmailBoleto();
    this.setState({ loadingEmail: true });

    try {
      const headers = {
        access_token: this.state.token,
      };

      const response = await api.get(`industrial/customer/v1/customers/me`, {
        headers,
      });
      const { data } = response;
      const { email } = data;

      if (!email) {
        toast.error(
          'Não foi possível enviar o e-mail, por favor verifique em dados cadastrais se possui um e-mail cadastrado e validado'
        );
        this.setState({ loadingEmail: false });
        return;
      }

      const body = {
        deliveryMethod: 'EMAIL',
        email,
      };
      await api.post(
        `industrial/invoice/v1/bills/${this.state.invoice.id}`,
        body,
        { headers }
      );
      toast.success(`Boleto enviado para o e-mail: ${email}`);
      this.setState({ loadingEmail: false });
    } catch (err) {
      this.setState({ loadingEmail: false });
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  };

  getStatusColor = (status) => {
    status = (status || '').replace('_', ' ').toLocaleLowerCase();
    return status === 'pago'
      ? '#75B943'
      : status === 'vencido'
      ? '#e34e2a'
      : status === 'a vencer'
      ? '#f0b01b'
      : '#000';
  };

  analisticsEmailBoleto() {
    firebase.analytics().logEvent('email_boleto', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        email_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        email_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    this.setState({ loadingEmail: true });
  }

  analyticsDownloadBoleto() {
    firebase.analytics().logEvent('download_boleto', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        download_boleto: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
  }

  getDateMI(date) {
    const dateMoment = moment(`${date}/01`);
    return dateFormat(dateMoment, 'mmmm/yyyy');
  }

  render() {
    const { props } = this;

    const emissionDate = `${props.invoice.emissionDate}T12:00:00`;
    const newEmissionDate = new Date(emissionDate);

    return (
      <div>
        <Tr>
          <Td>
            {props.activeModeDownload && (
              <SelectedItem
                selectAllInvoices={props.selectAllInvoices}
                selectedItem={props.selectedItem}
                disponibleForDownload={props.disponibleForDownload}
                onClick={(e) =>
                  this.handleOpenModal(e, false, false, false, true)}
              />
            )}
            {this.state.customerType === 'MI'
              ? this.getDateMI(props.installment.referenceMonth)
              : dateFormat(emissionDate, 'mmmm/yyyy')}
          </Td>
          <Td>{moment(props.installment.dueDate).format('DD/MM/YYYY')}</Td>
          <Td>
            {props.installment.amountOriginal ? (
              <Currency
                quantity={props.installment.amountOriginal}
                currency="BRL"
                locale="pt"
              />
            ) : (
              `R$ ${props.invoice.totalAmount}`
            )}
          </Td>
          <Td>
            <Status color={this.getStatusColor(props.status)} />
            <StatusTitle>{(props.status || '').replace('_', ' ')}</StatusTitle>
          </Td>
          <Td>{props.invoice.invoiceNumber}</Td>
          <Td>
            <DuplicateContainer>
              {props.status !== 'Pago' && props.disponibleForDownload ? (
                <>
                  <div>
                    {this.state.loadingDownload ? (
                      <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <>
                        <CustomToolip
                          componentShow={() => {
                            return (
                              <DescriptionTooltip>Download</DescriptionTooltip>
                            );
                          }}
                        >
                          <DuplicateIcon
                            className="mdi mdi-cloud-download-outline"
                            aria-label="Download"
                            data-tip
                            data-for="download-boleto"
                            onClick={(e) =>
                              this.handleOpenModal(e, false, true, false)}
                          />
                        </CustomToolip>
                      </>
                    )}
                  </div>

                  <div>
                    {this.state.loadingEmail ? (
                      <DuplicateLoading className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <>
                        <CustomToolip
                          componentShow={() => {
                            return (
                              <DescriptionTooltip>
                                Enviar boleto por e-mail
                              </DescriptionTooltip>
                            );
                          }}
                        >
                          <DuplicateIcon
                            className="mdi mdi-email-outline"
                            aria-label="Enviar boleto por e-mail"
                            data-tip
                            data-for="email-boleto"
                            onClick={(e) =>
                              this.handleOpenModal(e, false, false, true)}
                          />
                        </CustomToolip>
                      </>
                    )}
                  </div>
                </>
              ) : null}
              <>
                <CustomToolip
                  componentShow={() => {
                    return (
                      <DescriptionTooltip>Mais Informações</DescriptionTooltip>
                    );
                  }}
                >
                  <DuplicateIcon
                    className="mdi mdi-eye-outline"
                    aria-label="Mais Informações"
                    data-tip
                    data-for="info-boleto"
                    onClick={(e) => this.handleOpenModal(e, true)}
                  />
                </CustomToolip>
              </>
              <>
                {props.status.toLocaleLowerCase() !== 'pago' && (
                  <CustomToolip
                    title="Tempo de compensação do pagamento"
                    componentShow={() => {
                      return (
                        <BankslipInformations>
                          <ItemWrap>
                            <Item>Boleto:</Item>
                            <ItemDescription>
                              A Ultragaz recebe a confirmação de pagamento, em
                              média, 3 dias úteis após o pagamento. Após este
                              prazo o status de seu boleto será atualizado em
                              nossos canais.
                            </ItemDescription>
                          </ItemWrap>
                          <ItemWrap>
                            <Item>PIX:</Item>
                            <ItemDescription>
                              A Ultragaz recebe a confirmação de pagamento, em
                              média, 2 minutos após o pagamento. Após esse
                              prazo, o status de seu boleto será atualizado em
                              nossos canais.
                            </ItemDescription>
                          </ItemWrap>
                        </BankslipInformations>
                      );
                    }}
                  >
                    <DuplicateIcon
                      className="mdi mdi-information-outline"
                      aria-label="Informações"
                      data-tip
                      data-for="info-boleto"
                      onClick={(e) => this.handleOpenModal(e, false, false)}
                    />
                  </CustomToolip>
                )}
              </>
            </DuplicateContainer>
          </Td>
        </Tr>

        {/* Responsive View */}
        <Card>
          <CardTop>
            {props.activeModeDownload && (
              <SelectedItem
                selectAllInvoices={props.selectAllInvoices}
                selectedItem={props.selectedItem}
                disponibleForDownload={props.disponibleForDownload}
                onClick={(e) =>
                  this.handleOpenModal(e, false, false, false, true)}
              />
            )}
            <OptionsIcon>
              <SlOptions
                key={`card_${props.installment.installmentId}`}
                onClick={(e) => this.handleOpenModal(e, true)}
              />
            </OptionsIcon>
          </CardTop>
          <CardLine>
            <CodeTitle>Referência</CodeTitle>
            <Code>
              {this.state.customerType === 'MI'
                ? this.getDateMI(props.installment.referenceMonth)
                : dateFormat(emissionDate, 'mmmm/yyyy')}
            </Code>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Vencimento</TitleLine>
            <DescriptionLine>
              {moment(props.installment.dueDate).format('DD/MM/YYYY')}
            </DescriptionLine>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Valor</TitleLine>
            <DescriptionLine>
              {props.installment.amountOriginal ? (
                <Currency
                  quantity={props.installment.amountOriginal}
                  currency="BRL"
                  locale="pt"
                />
              ) : (
                `R$ ${props.invoice.totalAmount}`
              )}
            </DescriptionLine>
          </CardLine>

          <Hr />

          <CardLine>
            <TitleLine>Status</TitleLine>
            <DescriptionLine>
              <Status color={this.getStatusColor(props.status)} />
              <StatusTitle>
                {(props.status || '').replace('_', ' ')}
              </StatusTitle>
            </DescriptionLine>
          </CardLine>
        </Card>
      </div>
    );
  }
}
